<template>
  <div class="marketplace-empty-banner">
    <div class="empty-content">
      <div class="empty-icon">
        <img src="@/assets/images/noData.png" alt="">
      </div>

      <div class="empty-text">
        <h2 v-if="searchQuery">
          {{ $t('no_courses_found_for') }} "<strong>{{ searchQuery }}</strong>"
        </h2>
        <h2 v-else>
          {{ $t('no_courses_found') }}
        </h2>

        <p class="empty-description">
          {{ $t('marketplace_empty_description') }}
        </p>

        <div class="search-tips">
          <h4>{{ $t('search_suggestions') }}:</h4>
          <ul>
            <li>{{ $t('check_spelling') }}</li>
            <li>{{ $t('try_different_keywords') }}</li>
            <li>{{ $t('try_more_general_terms') }}</li>
            <li>{{ $t('try_fewer_filters') }}</li>
          </ul>
        </div>

        <div class="suggested-actions">
          <button class="dark-button-outline" @click="$emit('clear-filters')" v-if="hasFilters">
            <img class="btn-icon" src="@/assets/images/trash.svg" alt="">
            {{ $t('clear_all_filters') }}
          </button>

          <button class="primary-button" @click="$emit('browse-all')">
            <img class="btn-icon" src="@/assets/images/eyesSearch.svg" alt="">
            {{ $t('browse_all_courses') }}
          </button>
        </div>

        <div class="popular-categories" v-if="popularCategories?.length > 0">
          <h4>{{ $t('popular_categories') }}:</h4>
          <div class="category-tags">
            <button
              v-for="category in popularCategories"
              :key="category.id"
              class="category-tag"
              @click="$emit('category-selected', category)"
            >
              {{ category.title }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarketplaceEmptyBanner',
  props: {
    searchQuery: {
      type: String,
      default: ''
    },
    hasFilters: {
      type: Boolean,
      default: false
    },
    popularCategories: {
      type: Array,
      default: () => []
    }
  },
  emits: ['clear-filters', 'browse-all', 'category-selected']
}
</script>

<style scoped>
.marketplace-empty-banner {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border: 2px dashed #e1e5e9;
  border-radius: 12px;
  margin: 40px 0;
  padding: 60px 40px;
  text-align: center;
}

.empty-content {
  max-width: 600px;
  margin: 0 auto;
}

.empty-icon {
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
}

.empty-icon img{
 display: flex;
  height: 130px;
  width: 130px;
}

.empty-text h2 {
  font-family: 'euclid_bold', sans-serif;
  font-size: 28px;
  color: #1c1d1f;
  margin: 0 0 16px 0;
  line-height: 1.3;
}

.empty-text h2 strong {
  color: #5624d0;
}

.empty-description {
  font-size: 16px;
  color: #6a6f73;
  margin: 0 0 32px 0;
  line-height: 1.5;
}

.search-tips {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  padding: 20px;
  margin: 24px 0;
  text-align: left;
}

.search-tips h4 {
  font-family: 'euclid_bold', sans-serif;
  font-size: 16px;
  color: #856404;
  margin: 0 0 12px 0;
}

.search-tips ul {
  margin: 0;
  padding-left: 20px;
  list-style-type: disc;
}

.search-tips li {
  font-size: 14px;
  color: #856404;
  margin: 6px 0;
  line-height: 1.4;
}

.suggested-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  margin: 32px 0;
  flex-wrap: wrap;
}

.btn-icon {
  font-size: 18px;
}

.popular-categories {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #e1e5e9;
}

.popular-categories h4 {
  font-family: 'euclid_bold', sans-serif;
  font-size: 16px;
  color: #1c1d1f;
  margin: 0 0 16px 0;
}

.category-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.category-tag {
  background: #f7f9fa;
  color: #5624d0;
  border: 1px solid #d1d7dc;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

@media (max-width: 768px) {
  .marketplace-empty-banner {
    padding: 40px 20px;
    margin: 20px 0;
  }

  .empty-text h2 {
    font-size: 24px;
  }

  .suggested-actions {
    flex-direction: column;
    align-items: center;
  }

  .category-tags {
    gap: 6px;
  }

  .category-tag {
    font-size: 12px;
    padding: 6px 12px;
  }
}
</style>
